import { SafeUrl } from "@angular/platform-browser";

export class SearchCouncellorResultDto {
    CouncellorName: string;
}
export class SearchCouncellorDto {
    SearchKey: string;
    InstanceId: number;
    ResourceId: number;
}